namespace advisorop.domains {

    export interface IMemoAccount {

        id: number;

        investorId: number;

        dateCreate: Date;

        memoHoldingTypeId: number;

        currencyId: number;

        nativeMarketValue: number;

        usdMarketValue: number;

        includeInAUM: boolean;

        description: string;

        systemLoginId: string;



        companyGroup: domains.ICompanyGroup;

        systemLogin: domains.identity.IUser;
    }

    export class MemoAccount implements IMemoAccount {
        constructor() {
            //this.companyGroup = new domains.CompanyGroup();
        }

        public id: number;

        public investorId: number;

        public dateCreate: Date;

        public memoHoldingTypeId: number;

        public currencyId: number;

        public nativeMarketValue: number;

        public usdMarketValue: number;

        public includeInAUM: boolean;

        public description: string;

        public systemLoginId: string;



        public companyGroup: domains.ICompanyGroup;

        public systemLogin: domains.identity.IUser;
    }
}